import React from 'react'
import PropTypes from 'prop-types'
import Step from '../../../components/Step'
import Select from 'react-select'
import _ from 'lodash'
import PROPTYPES from '../../../lib/propTypes'
import * as validation from 'lib/validation'
import './SiteTools.scss'

const ORGANIZATION = 'Organization'

const USER = 'User'
const USER_PASSWORD = 'UserPassword'

const SITE = 'Site'
const SITE_ADDRESS = 'SiteAddress'
const SITE_TEST_STRIP_COUNT = 'SiteTestStripCount'

const PRESCRIBER = 'Prescriber'
const PRESCRIBER_ADDRESS = 'PrescriberAddress'
const PRESCRIBER_PHONE_NUMBER = 'PrescriberPhoneNumber'
const PRESCRIBER_NPI = 'PrescriberNPI'
const PRESCRIBER_SIGNATURE = 'PrescriberSignature'
const PRESCRIBER_EMAIL = 'PrescriberEmail'

const DEVICES = 'Devices'
const PHARMACY = 'Pharmacy'

export default class SiteCreationView extends React.Component {
  static propTypes = {
    isFetchingOrganizations: PropTypes.bool,
    isFetchingUsers: PropTypes.bool,
    isFetchingSites: PropTypes.bool,
    isFetchingDevices: PropTypes.bool,
    isFetchingPrescribers: PropTypes.bool,
    isFetchingPharmacies: PropTypes.bool,
    isUpdatingPrescriber: PropTypes.bool,
    pharmacies: PROPTYPES.pharmacies,
    createOrganization: PropTypes.func,
    createdOrganization: PROPTYPES.organization,
    createUser: PropTypes.func,
    createdUser: PROPTYPES.user,
    updatedUser: PROPTYPES.user,
    users: PROPTYPES.users,
    organizations: PROPTYPES.organizations,
    createSite: PropTypes.func,
    updateSite: PropTypes.func,
    createdSite: PROPTYPES.site,
    sites: PROPTYPES.sites,
    createPrescriber: PropTypes.func,
    createdPrescriber: PROPTYPES.prescriber,
    addPrescriberToSite: PropTypes.func,
    updatedPrescriber: PROPTYPES.prescriber,
    uploadSignature: PropTypes.func,
    uploadedSignature: PropTypes.bool,
    prescribers: PROPTYPES.prescribers,
    devices: PROPTYPES.devices,
    associateDeviceWithSite: PropTypes.func,
    dissociateDeviceWithSite: PropTypes.func,
  }

  static defaultProps = {
    isFetchingOrganizations: false,
    isFetchingUsers: false,
    isFetchingSites: false,
    isFetchingDevices: false,
    isFetchingPrescribers: false,
    isFetchingPharmacies: false,
    isUpdatingPrescriber: false,
    pharmacies: [],
    createOrganization: _.noop,
    createdOrganization: null,
    createUser: _.noop,
    createdUser: null,
    updatedUser: null,
    users: [],
    organizations: [],
    createSite: _.noop,
    createdSite: null,
    sites: [],
    createPrescriber: _.noop,
    addPrescriberToSite: _.noop,
    uploadSignature: _.noop,
    createdPrescriber: null,
    updatedPrescriber: null,
    uploadedSignature: false,
    prescribers: [],
    devices: [],
    associateDeviceWithSite: _.noop,
    dissociateDeviceWithSite: _.noop,
  }

  constructor (props) {
    super(props)
    this.state = {
      [`selected${ORGANIZATION}`]: null,
      [`selected${USER}`]: null,
      [`selected${USER_PASSWORD}`]: null,
      [`selected${SITE}`]: null,
      [`selected${PRESCRIBER}`]: null,
      [`selected${DEVICES}`]: null,
      [`selected${PHARMACY}`]: null,
      [`input${ORGANIZATION}`]: '',
      [`input${USER}`]: '',
      [`input${USER_PASSWORD}`]: '',
      [`input${SITE}`]: '',
      [`input${SITE_ADDRESS}`]: '',
      [`input${SITE_TEST_STRIP_COUNT}`]: '',
      [`input${PRESCRIBER}`]: '',
      [`input${PRESCRIBER_EMAIL}`]: '',
      [`input${PRESCRIBER_ADDRESS}`]: '',
      [`input${PRESCRIBER_PHONE_NUMBER}`]: '',
      [`input${PRESCRIBER_NPI}`]: '',
      [`input${PRESCRIBER_SIGNATURE}`]: '',
      [`input${DEVICES}`]: '',
      [`input${PHARMACY}`]: '',
      devicesComplete: false,
    }
  }

  // check to see if requirements are met before enabling user to take action, true if prereqs met
  checkPrereqs = (resourceType) => {
    const self = this
    const {
      selectedOrganization,
      selectedUser,
      selectedSite,
      inputOrganization,
      inputUser,
      inputUserPassword,
      inputSite,
      inputSiteAddress,
      selectedPharmacy,
      inputPrescriber,
      inputPrescriberAddress,
      inputPrescriberPhoneNumber,
      inputPrescriberNPI,
      inputPrescriberSignature,
      selectedPrescriber,
      selectedDevices,
    } = this.state
    const { createdOrganization, createdUser, createdSite, createdPrescriber, updatedPrescriber, uploadedSignature } = this.props
    if (resourceType === ORGANIZATION) {
      if ((selectedOrganization || createdOrganization) || (inputOrganization)) {
        return true
      }
    }
    if (resourceType === USER) {
      if (self.checkPrereqs(ORGANIZATION) && ((selectedUser || createdUser) || (inputUser && inputUserPassword))) {
        return true
      }
    }
    if (resourceType === SITE) {
      if (selectedSite || createdSite) {
        return true
      }
      if (self.checkPrereqs(ORGANIZATION) && self.checkPrereqs(USER)) {
        if (inputSite && inputSiteAddress && selectedPharmacy) {
          return true
        }
      }
    }
    if (resourceType === PRESCRIBER) {
      // for each step, check if resource has been created or selected, so we can recursively check previous reqs
      if (selectedPrescriber || createdPrescriber) {
        return true
      }
      if (self.checkPrereqs(SITE)) {
        if (inputPrescriber && inputPrescriberAddress && inputPrescriberPhoneNumber &&
          inputPrescriberNPI) {
          return true
        }
      }
    }
    if (resourceType === PRESCRIBER_SIGNATURE) {
      if (uploadedSignature) {
        return true
      }
      if ((selectedPrescriber || createdPrescriber || updatedPrescriber) && inputPrescriberSignature) {
        return true
      }
    }
    if (resourceType === DEVICES) {
      if (selectedSite || createdSite) {
        if (selectedDevices && selectedDevices.length > 0) {
          return true
        }
      }
    }
    return false
  }

  handleSelect = (resourceType, selected) => {
    if (selected == null) {
      selected = ''
    }
    this.setState({ [`selected${resourceType}`]: selected })
  }

  handleInput = (resourceType, input) => {
    this.setState({ [`input${resourceType}`]: input })
    return input
  }

  getDeviceIds = () => {
    const { selectedDevices } = this.state
    return _.map(selectedDevices, (device) => {
      return device.device_id
    })
  }

  getDeviceStrings = () => {
    const { selectedDevices } = this.state
    return _.map(selectedDevices, (device) => {
      return device.id // device_string is returned by api as id and device_string
    })
  }

  handleAssociatesDevicesClick = (site) => {
    this.setState({ devicesComplete: true })
    const deviceStrings = this.getDeviceStrings()
    return Promise.all(_.map(deviceStrings, (deviceString) => {
    	return this.props.associateDeviceWithSite(site.id, deviceString)
    }))
  }

  handleDissociatesDevicesClick = (site) => {
    this.setState({ devicesComplete: true })
    const deviceStrings = this.getDeviceStrings()
    return Promise.all(_.map(deviceStrings, (deviceString) => {
    	return this.props.dissociateDeviceWithSite(site.id, deviceString)
    }))
  }


  isPrescriberLinkedToSite = (prescriber, site) => {
    return prescriber.site_ids.includes(site.id)
  }

  handleCreateUser = (organization) => {
    const { inputUser, inputUserPassword } = this.state
    const { createUser } = this.props
    const userResult = validation.validateUser(inputUser)
    const passwordResult = validation.validatePassword(inputUserPassword)
    this.setState({
      [`alert${USER}`]: {
        show: !userResult.valid,
        errors: userResult.errors
      },
      [`alert${USER_PASSWORD}`]: {
        show: !passwordResult.valid,
        errors: passwordResult.errors
      }
    })
    if (userResult.valid && passwordResult.valid) {
      createUser(inputUser, inputUserPassword, 'CLOZ_ADMIN', organization.id)
    }
  }

  handleCreatePrescriber = (currentSite) => {
    const {
      inputPrescriber,
      inputPrescriberEmail,
      inputPrescriberPhoneNumber,
      inputPrescriberAddress,
      inputPrescriberNPI,
      inputPrescriberSignature
    } = this.state
    const { createPrescriber } = this.props
    const prescriberResult = validation.validatePrescriberName(inputPrescriber)
    const emailResult = validation.validateEmail(inputPrescriberEmail, false)
    const phoneResult = validation.validatePhoneNumber(inputPrescriberPhoneNumber)
    const npiResult = validation.validateNPI(inputPrescriberNPI)

    this.setState({
      [`alert${PRESCRIBER}`]: {
        show: !prescriberResult.valid,
        errors: prescriberResult.errors
      },
      [`alert${PRESCRIBER_EMAIL}`]: {
        show: !emailResult.valid,
        errors: emailResult.errors
      },
      [`alert${PRESCRIBER_PHONE_NUMBER}`]: {
        show: !phoneResult.valid,
        errors: phoneResult.errors
      },
      [`alert${PRESCRIBER_NPI}`]: {
        show: !npiResult.valid,
        errors: npiResult.errors
      }
    })

    if (prescriberResult.valid && emailResult.valid && phoneResult.valid && npiResult.valid) {
      createPrescriber(
        inputPrescriber.split(' ')[0],
        inputPrescriber.split(' ')[1],
        inputPrescriberEmail,
        inputPrescriberAddress,
        inputPrescriberPhoneNumber,
        inputPrescriberNPI,
        [currentSite.id],
        inputPrescriberSignature,
      )
    }
  }

  handleUpdateSite = (currentOrganization, currentUserSubject) => {
    const { updateSite } = this.props
    const { selectedSite, inputSite, inputSiteAddress, inputSiteTestStripCount } = this.state
    const testStripCountResult = validation.validateNumber(inputSiteTestStripCount, false)
    const updatedUserIds = _.uniq((selectedSite.users || []).concat([currentUserSubject.user_id]))
    const updatedSite = _.merge(selectedSite, { test_strip_count: inputSiteTestStripCount, address: inputSiteAddress, user_ids: updatedUserIds })
    if (testStripCountResult.valid) {
      updateSite(
        updatedSite
      )
    }
  }

  handleCreateSite = (currentOrganization, currentUserSubject) => {
    const { createSite } = this.props
    const { inputSite, inputSiteAddress, inputSiteTestStripCount, selectedPharmacy } = this.state
    const testStripCountResult = validation.validateNumber(inputSiteTestStripCount, false)
    this.setState({
      [`alert${SITE_TEST_STRIP_COUNT}`]: {
        show: !testStripCountResult.valid,
        errors: testStripCountResult.errors
      }
    })
    if (testStripCountResult.valid) {
      createSite(
        inputSite,
        inputSiteAddress,
        currentOrganization.id,
        selectedPharmacy.id,
        currentUserSubject.user_id,
        inputSiteTestStripCount,
      )
    }
  }

  handleUploadPrescriberSignature = () => {
    const { inputPrescriberSignature } = this.state
    const { uploadSignature } = this.props
    const prescriber = this.getCurrentPrescriber()
    uploadSignature(prescriber.id, inputPrescriberSignature)
  }

  renderAlert = (resourceType) => {
    const alert = this.state[`alert${resourceType}`]
    if (alert && alert.show) {
      return _.map(alert.errors, (error, index) => (
        <div className='alert alert-danger' key={index}>{error}</div>
      ))
    }
  }

  renderPrescriberSignatureInput = (optional = false) => {
    const { inputPrescriberSignature } = this.state
    return (
      <div>
        <div>Signature {optional ? '(Optional)' : ''}</div>
        <input
          type='file'
          onChange={(event) => this.handleInput(PRESCRIBER_SIGNATURE, event.target.files[0])}
        />
        {
          inputPrescriberSignature
          ? <img className='signature' src={URL.createObjectURL(inputPrescriberSignature)} />
          : null
        }
      </div>
    )
  }

  getCurrentPrescriber = () => {
    const { updatedPrescriber, createdPrescriber } = this.props
    const { selectedPrescriber } = this.state

    return updatedPrescriber || createdPrescriber || selectedPrescriber || null
  }

  render () {
    const {
      isFetchingOrganizations,
      isFetchingSites,
      isFetchingDevices,
      isFetchingPrescribers,
      isFetchingPharmacies,
      isFetchingUsers,
      createOrganization,
      createdOrganization,
      organizations,
      createdUser,
      updatedUser,
      users,
      createdSite,
      sites,
      addPrescriberToSite,
      updatedPrescriber,
      uploadedSignature,
      prescribers,
      devices,
      pharmacies,
    } = this.props
    const {
      selectedOrganization,
      selectedUser,
      selectedSite,
      selectedPrescriber,
      selectedDevices,
      selectedPharmacy,
      inputOrganization,
      inputUserPassword,
      inputSiteAddress,
      inputSiteTestStripCount,
      inputPrescriberEmail,
      inputPrescriberAddress,
      inputPrescriberPhoneNumber,
      inputPrescriberNPI,
      devicesComplete,
    } = this.state
    const currentOrganization = createdOrganization || selectedOrganization || null
    const currentUserSubject = updatedUser || createdUser || selectedUser || null
    const currentSite = createdSite || selectedSite || null
    const currentPrescriber = this.getCurrentPrescriber()
    return (
      <div className='step-form'>
        <div>
          <Step
            title='Organization'
            isCollapsed={!!currentOrganization}
          >
            {
              currentOrganization
              ? <div>
                { `${currentOrganization.name}` }
              </div>
              : <div>
                <div>Name</div>
                <Select
                  isSearchable
                  isClearable
                  isLoading={isFetchingOrganizations}
                  options={organizations}
                  value={selectedOrganization}
                  onChange={(selected) => this.handleSelect(ORGANIZATION, selected)}
                  onInputChange={(input) => this.handleInput(ORGANIZATION, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'name'}
                  valueKey={'id'}
                />
                <div className='button-container'>
                  <button
                    className='btn btn-primary action-button'
                    onClick={() => createOrganization(inputOrganization)}
                    disabled={!this.checkPrereqs(ORGANIZATION)}
                  >
                    Create Organization
                  </button>
                </div>
              </div>
            }
          </Step>

          <Step
            title='User'
            isCollapsed={!!currentUserSubject}
          >
            {
              currentUserSubject
              ? <div>
                { currentUserSubject.email }
              </div>
              : <div>
                <div>Username</div>
                { this.renderAlert(USER) }
                <Select
                  isSearchable
                  isClearable
                  isLoading={isFetchingUsers}
                  options={users}
                  value={selectedUser}
                  onChange={(selected) => this.handleSelect(USER, selected)}
                  onInputChange={(input) => this.handleInput(USER, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'email'}
                  valueKey={'user_id'}
                />
                <div>Password</div>
                { this.renderAlert(USER_PASSWORD) }
                <input
                  type='password'
                  className='input'
                  value={inputUserPassword}
                  onChange={(event) => this.handleInput(USER_PASSWORD, event.target.value)}
                />
                <div className='button-container'>
                  <button
                    className='btn btn-primary action-button'
                    onClick={() => this.handleCreateUser(currentOrganization)}
                    disabled={!this.checkPrereqs(USER)}
                  >
                    Create User
                  </button>
                </div>
              </div>
            }
          </Step>

          <Step
            title='Site'
            isCollapsed={!_.isEmpty(createdSite)}
          >
            {
              !_.isEmpty(createdSite)
              ? <div />
              : (
                currentSite && _.isEmpty(createdSite)
                ? (
                  <div>
                    <div>Site is Created/Selected</div>
                    <Select
                      isSearchable
                      isClearable
                      isLoading={isFetchingSites}
                      options={sites}
                      value={selectedSite}
                      onChange={(selected) => this.handleSelect(SITE, selected)}
                      onInputChange={(input) => this.handleInput(SITE, input)}
                      onBlurResetsInput={false}
                      onCloseResetsInput={false}
                      noResultsText={false}
                      labelKey={'name'}
                      valueKey={'id'}
                    />
                    <div>Updated At: {new Date(currentSite.updated_at).toLocaleString()}</div>
                    <div>Address</div>
                    <input
                      type='text'
                      className='input'
                      value={inputSiteAddress || currentSite.address}
                      onChange={(event) => this.handleInput(SITE_ADDRESS, event.target.value)}
                    />
                    <div>Pharmacy</div>
                    <Select
                      isSearchable
                      isClearable
                      isLoading={isFetchingPharmacies}
                      options={pharmacies}
                      value={selectedPharmacy}
                      onChange={(selected) => this.handleSelect(PHARMACY, selected)}
                      onBlurResetsInput={false}
                      onCloseResetsInput={false}
                      noResultsText={false}
                      labelKey={'name'}
                      valueKey={'id'}
                    />
                    <div>Test Strip Count</div>
                    { this.renderAlert(SITE_TEST_STRIP_COUNT) }
                    <input
                      type='text'
                      className='input'
                      value={inputSiteTestStripCount || currentSite.test_strip_count}
                      onChange={(event) => this.handleInput(SITE_TEST_STRIP_COUNT, event.target.value)}
                    />
                    <div className='button-container'>
                      <button
                        className='btn btn-primary action-button'
                        onClick={() => this.handleUpdateSite(currentOrganization, currentUserSubject)}
                        disabled={!this.checkPrereqs(SITE)}
                      >
                        Update Site
                      </button>
                    </div>
                  </div>
                ) : <div>
                  <div>Name</div>
                  <Select
                    isSearchable
                    isClearable
                    isLoading={isFetchingSites}
                    options={sites}
                    value={selectedSite}
                    onChange={(selected) => this.handleSelect(SITE, selected)}
                    onInputChange={(input) => this.handleInput(SITE, input)}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    noResultsText={false}
                    labelKey={'name'}
                    valueKey={'id'}
                  />
                  <div>Address</div>
                  <input
                    type='text'
                    className='input'
                    value={inputSiteAddress}
                    onChange={(event) => this.handleInput(SITE_ADDRESS, event.target.value)}
                  />
                  <div>Pharmacy</div>
                  <Select
                    isSearchable
                    isClearable
                    isLoading={isFetchingPharmacies}
                    options={pharmacies}
                    value={selectedPharmacy}
                    onChange={(selected) => this.handleSelect(PHARMACY, selected)}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    noResultsText={false}
                    labelKey={'name'}
                    valueKey={'id'}
                  />
                  <div>Test Strip Count</div>
                  { this.renderAlert(SITE_TEST_STRIP_COUNT) }
                  <input
                    type='text'
                    className='input'
                    value={inputSiteTestStripCount}
                    onChange={(event) => this.handleInput(SITE_TEST_STRIP_COUNT, event.target.value)}
                  />
                  <div className='button-container'>
                    <button
                      className='btn btn-primary action-button'
                      onClick={() => this.handleCreateSite(currentOrganization, currentUserSubject)}
                      disabled={!this.checkPrereqs(SITE)}
                    >
                      Create Site
                    </button>
                  </div>
                </div>
              )
            }
          </Step>

          <Step
            title='Prescriber'
            isCollapsed={!!currentPrescriber}
          >
            {
              currentPrescriber
              ? <div>
                {
                  !updatedPrescriber && selectedPrescriber && currentSite && !this.isPrescriberLinkedToSite(selectedPrescriber, currentSite)
                  ? <button
                    className='btn btn-primary update-button'
                    onClick={() => addPrescriberToSite(currentPrescriber.id, currentSite.id)}
                  >
                    Add to {`${currentSite.name}`}
                  </button>
                  : null
                }
                { `${currentPrescriber.name}` }
              </div>
              : <div>
                <div>Name</div>
                { this.renderAlert(PRESCRIBER) }
                <Select
                  isSearchable
                  isClearable
                  isLoading={isFetchingPrescribers}
                  options={prescribers}
                  value={selectedPrescriber}
                  onChange={(selected) => this.handleSelect(PRESCRIBER, selected)}
                  onInputChange={(input) => this.handleInput(PRESCRIBER, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'name'}
                  valueKey={'id'}
                />
                <div>Email</div>
                { this.renderAlert(PRESCRIBER_EMAIL) }
                <input
                  type='email'
                  className='input'
                  value={inputPrescriberEmail}
                  onChange={(event) => this.handleInput(PRESCRIBER_EMAIL, event.target.value)}
                />
                <div>Address</div>
                <input
                  type='text'
                  className='input'
                  value={inputPrescriberAddress}
                  onChange={(event) => this.handleInput(PRESCRIBER_ADDRESS, event.target.value)}
                />
                <div>Phone Number</div>
                { this.renderAlert(PRESCRIBER_PHONE_NUMBER) }
                <input
                  type='text'
                  className='input'
                  value={inputPrescriberPhoneNumber}
                  onChange={(event) => this.handleInput(PRESCRIBER_PHONE_NUMBER, event.target.value)}
                />
                <div>NPI</div>
                { this.renderAlert(PRESCRIBER_NPI) }
                <input
                  type='text'
                  className='input'
                  value={inputPrescriberNPI}
                  onChange={(event) => this.handleInput(PRESCRIBER_NPI, event.target.value)}
                />
                {
                  this.renderPrescriberSignatureInput(true)
                }
                <div className='button-container'>
                  <button
                    className='btn btn-primary action-button'
                    onClick={() => this.handleCreatePrescriber(currentSite)}
                    disabled={!this.checkPrereqs(PRESCRIBER)}
                  >
                    Create Prescriber
                  </button>
                </div>
              </div>
            }
          </Step>
          <Step
            title={`Prescriber Signature ${currentPrescriber ? '' : '(Select or Create Prescriber above)'}`}
            isCollapsed={!!uploadedSignature}
          >
            {
              uploadedSignature
              ? <div>
                Signature Upload Successful
              </div>
              : <div>
                {this.renderPrescriberSignatureInput()}
                <div className='button-container'>
                  <button
                    className='btn btn-primary action-button'
                    onClick={() => this.handleUploadPrescriberSignature()}
                    disabled={!this.checkPrereqs(PRESCRIBER_SIGNATURE)}
                  >
                    Upload Signature
                  </button>
                </div>
              </div>
            }
          </Step>
          <Step
            title='Devices'
            isCollapsed={!!devicesComplete}
          >
            {
              devicesComplete
              ? <div className='device-id-container'>
                {`${this.getDeviceStrings()}` }
              </div>
              : <div>
                <div>Device Strings</div>
                <Select
                  multi
                  isSearchable
                  isClearable
                  isLoading={isFetchingDevices}
                  options={devices}
                  value={selectedDevices}
                  onChange={(selected) => this.handleSelect(DEVICES, selected)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'device_string'}
                  valueKey={'id'}
                />
                <div className='button-container'>
                  <button
                    className='btn btn-primary action-button'
                    onClick={() => this.handleAssociatesDevicesClick(currentSite)}
                    disabled={!this.checkPrereqs(DEVICES)}
                  >
                    Associate Devices
                  </button>
                </div>
                <div className='button-container'>
                  <button
                    className='btn btn-primary action-button'
                    onClick={() => this.handleDissociatesDevicesClick(currentSite)}
                    disabled={!this.checkPrereqs(DEVICES)}
                  >
                    Dissociate Devices
                  </button>
                </div>
              </div>
            }
          </Step>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Clinic/components/SiteCreationView.jsx